import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Http from "../Common/Http";

const Login = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    email: "",
    password: "12345678", // Default password
  });
  const [message, setMessage] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Clear sensitive data when component unmounts
  useEffect(() => {
    return () => {
      setInputs({});
    };
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    // Only trim email, not password
    const trimmedValue = name === "email" ? value.trim() : value;
    setInputs((values) => ({ ...values, [name]: trimmedValue }));
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Prevent double submission

    try {
      setIsSubmitting(true);
      const res = await Http.post("/login", inputs);

      // Store tokens securely
      localStorage.setItem("token", res.data.token);
      sessionStorage.setItem("token", res.data.token);

      // Clear sensitive data
      setInputs({});

      window.location.href = "/dashboard";
    } catch (error) {
      setMessage(
        error.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Email validation function
  const isEmailValid = () => {
    return inputs.email && inputs.email.includes("@");
  };

  // Password validation function
  const isPasswordValid = () => {
    return inputs.password && inputs.password.length >= 8;
  };

  return (
    <div>
      {/* <IsLogin></IsLogin> */}
      <div className="am-signin-wrapper">
        <div className="am-signin-box">
          <div className="row no-gutters">
            <div className="col-lg-5">
              <div>
                <h2>Artisan ERP</h2>

                <hr />
                <p>
                  Don&apos;t have an account? <br /> <a href="#">Sign up Now</a>
                </p>
              </div>
            </div>
            <div className="col-lg-7">
              <h5 className="tx-gray-800 mg-b-25">Signin to Your Account</h5>

              <form onSubmit={formSubmit}>
                <div className="form-group">
                  <label className="form-control-label">Email:</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    onChange={handleChange}
                    placeholder="Enter your email address"
                  />
                </div>

                <div className="form-group">
                  <label className="form-control-label">Password:</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    onChange={handleChange}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    minLength="8"
                    required
                  />
                </div>

                <div className="form-group mg-b-20">
                  <a href="">Reset password</a>
                </div>

                <button
                  type="submit"
                  className="btn btn-block"
                  disabled={
                    isSubmitting || !isEmailValid() || !isPasswordValid()
                  }
                >
                  {isSubmitting ? "Signing In..." : "Sign In"}
                </button>
              </form>
              <p style={{ color: "red", marginTop: "20px" }}>{message}</p>
            </div>
          </div>
          <p className="tx-center tx-white-5 tx-12 mg-t-15">
            Copyright &copy; {new Date().getFullYear()}. All Rights Reserved. by{" "}
            <a href="https://limerickbd.com" target="_blank" rel="noreferrer">
              Limerick Resources Limited
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
